import React, { useState, useEffect } from "react";
import {
  Card,
  makeStyles,
  CardHeader,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  CardContent,
} from '@material-ui/core';


import { createTheme } from '@material-ui/core/styles';
import firebase from '../../../../Firebase';
import 'firebase/database';
import { deepOrange, deepPurple, green } from '@material-ui/core/colors';
import { FormattedMessage, useIntl } from "react-intl";

import id_default from 'images/sensor_map/id_default.png';

const ImageView = props => {
  const { className, history, roomId, roomName, dataList, ...rest } = props;
  const classes = useStyles();
  const { formatMessage } = useIntl();

  const [deviceList, setDeviceList] = useState([]);


  const fetchImages = async () => {

    const updatedDataList = await Promise.all(

      dataList.map(async (device) => {
        try {
          const imageUrl = await firebase
            .storage()
            .ref("sensor_map/" + device.deviceId + ".png")
            .getDownloadURL();

          return { ...device, imageUrl };

        } catch (error) {
          console.log("err: " + error);
          return { ...device, imageUrl: id_default };
        }
      })
    );

    // console.log(updatedDataList);
    setDeviceList(updatedDataList);
  };


  useEffect(() => {
    fetchImages();
  }, []);


  return (
    <Card className={classes.root}>

      <CardHeader
        className={classes.title}
        title={roomName}
        titleTypographyProps={{ align: 'center', color: 'inherit', variant: 'h5' }}
      />

      <CardContent className={classes.cardcontent}>

        <ImageList sx={{ width: 1600, height: 800 }} cols={3} gap={8} variant="standard"
        // rowHeight={420} 
        >

          {deviceList.map((item) => (
            <ImageListItem cols={1} rows={1} key={item.deviceId} 
            style={{height: 'auto'}}
            // style={{height: 420}}
            >

              <img src={item.imageUrl}
                align="center"
                // alt={item.roomName + ' - ' + item.installed_pos_detail}
                alt={item.imageUrl}
                loading="lazy"
                className={classes.imageViewer}
              />

              <ImageListItemBar
                subtitle={item.roomName + ' - ' + item.installed_pos_detail}
                className={classes.imageBar}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </CardContent>
    </Card>
  );
}


export default ImageView;


const theme = createTheme({
  overrides: {
    MuiCardContent: {
      root: {
        padding: 0,
        "&:last-child": {
          paddingBottom: 0,
        },
      },
    },
  }
})


const useStyles = makeStyles((theme) => ({

  imageBar: {
    height: theme.spacing(4),
  },
  //cardContent padding 조절
  cardcontent: {
    padding: 2,
    "&:last-child": {
      paddingBottom: 2
    }
  },

  root: {
  },

  title: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.siren_symbol.main2,
    height: 42,
  },

  imageViewer: {
    width:'100%',
    // height:'100%',
    // width: '524px',
    // height: '400px',
    objectFit: 'cover',
    // paddingTop: '-10px',
    marginTop: '-20px',
    // paddingBottom: '10px',
  }

}));